module.exports = __webpack_public_path__ + "static/media/juniper.94261e15.png";